import config from './../common/config'
import { TranslationFunction } from '../common/types'
import { format } from '../hooks/date'
import { FormattedBreadcrumbTransport } from '../models/common/breadcrumb-model'

/**
 * @deprecated
 *
 * Please do not use this method. Any new code should not use this method and should try to think of a
 * different solution.
 * @param path
 */
export const getBasePath = (path: string): string => {
    return `${config.assetPrefix}${path}`
}

export const getFormattedDate = (date: Date, sameYearDate: boolean): string => {
    return `${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}
    ${sameYearDate ? '' : date.getFullYear()}`
}

export const historyDateDisplay = (arrival: Date, departure: Date): string =>
    `${format(arrival, arrival.getFullYear() === departure.getFullYear() ? 'dd MMM' : 'dd MMM yyyy')} - ${format(
        departure,
        'dd MMM yyyy',
    )}`

export const getFeatureTextFromKey = (key: string, t: TranslationFunction): string | null => {
    switch (key) {
        case 'wifi':
            return t('featureWifi')
        case 'pets':
            return t('featurePets')
        case 'pets-prohibited':
            return t('featureNoPets')
        case 'pets-unspecified':
            return null
        case 'smoking':
            return t('featureSmoking')
        case 'smoking-prohibited':
            return t('featureSmokeFree')
        case 'smoking-unspecified':
            return null
        case 'washing-machine':
            return t('featureWashingMachine')
        case 'television':
            return t('featureTelevision')
        case 'pool':
            return t('featurePool')
        case 'dishwasher':
            return t('featureDishwasher')
        default:
            return t('featureWifi')
    }
}

export const getBreadcrumbSchemaDetail = (breadcrumbs: FormattedBreadcrumbTransport[]) => {
    const BreadcrumbSchema = breadcrumbs.map((item, index) => {
        return {
            '@type': 'ListItem',
            position: index,
            item: {
                '@id': item.url,
                name: item.title,
            },
        }
    })

    return {
        __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: BreadcrumbSchema,
        }),
    }
}

export const getSearchDate = (date: Date | null) => (date ? format(date, 'yyyy-MM-dd') : '')

/**
 * Calculates the adjusted total slides for a carousel to compensate for fractional visibleSlides.
 * This fixes the issue where the last slides are unreachable when dragging.
 */
export const getCarouselReachableSlideCount = (totalCount: number, visibleSlides: number): number => {
    const fractionalPart = visibleSlides - Math.floor(visibleSlides)
    const slideGroupCount = totalCount / visibleSlides
    return totalCount + (fractionalPart > 0 ? Math.ceil(fractionalPart) * slideGroupCount : 0)
}

export const getTruncatedTextByChars = (text: string, maxChars: number): string => {
    return text.length > maxChars ? `${text.slice(0, maxChars)}... ` : text
}

export const PARTNER_NAME_MAP: Record<string, string> = {
    hometogo: 'home-to-go',
    holidu: 'holidu',
}

export const normalizePartnerName = (name: string) => PARTNER_NAME_MAP[name.toLowerCase()] ?? name

export const getPartnerLogoUrl = (partnerName: string): string => {
    return getBasePath(`/images/external-partner-logos/${normalizePartnerName(partnerName)}.png`)
}
